/** The chat route, relative to the company; a chat's id follows it. */
export const OPERATOR_CHAT_PATH = "/operator/chat";

export const operatorChatPath = (chatId: string): string =>
  `${OPERATOR_CHAT_PATH}/${chatId}`;

/** The chat route as the router matches it, company slug first. */
export const OPERATOR_CHAT_ROUTE_PATTERN = "/:slug/operator/chat/:chatId?";

/**
 * The company's routines (its scheduled automations), inside the chat
 * route's shell.
 */
export const OPERATOR_ROUTINES_PATH = `${OPERATOR_CHAT_PATH}/routines`;

/**
 * A routine page's tabs, in order. Overview is the page's own address: its
 * path names no tab.
 */
const ROUTINE_TABS = ["overview", "runs", "activity"] as const;

export type RoutineTab = (typeof ROUTINE_TABS)[number];

export const isRoutineTab = (value: string): value is RoutineTab =>
  ROUTINE_TABS.some((tab) => tab === value);

/** One routine's page, on one of its tabs (Overview unless one is named). */
export const operatorRoutinePath = (
  automationId: string,
  tab: RoutineTab = "overview",
): string =>
  tab === "overview"
    ? `${OPERATOR_ROUTINES_PATH}/${automationId}`
    : `${OPERATOR_ROUTINES_PATH}/${automationId}/${tab}`;

/**
 * The routines view as the router matches it, below the company slug: the
 * list, or one routine's page on one of its tabs.
 */
export const OPERATOR_ROUTINES_ROUTE = `${OPERATOR_ROUTINES_PATH}/:routineId?/:tab?`;
export const OPERATOR_RELICS_PATH = "/operator/chat/relics";
export const OPERATOR_RELICS_ROUTE = `${OPERATOR_RELICS_PATH}/:relicId?`;
export const operatorRelicPath = (id: string, version?: number) =>
  `${OPERATOR_RELICS_PATH}/${id}${version === undefined ? "" : `?version=${version}`}`;

/** One run of an automation, opened as its task in the chat route. */
export const operatorChatTaskPath = (taskId: string): string =>
  `${OPERATOR_CHAT_PATH}/task/${taskId}`;

/** A run's task link as the router matches it, below the company slug. */
export const OPERATOR_CHAT_TASK_ROUTE = `${OPERATOR_CHAT_PATH}/task/:taskId`;
